import { STANDARD_EASING } from "@/shared/constants/motion";

export const VISIBLE_PIN_DURATION_IN_SECONDS = 30;

export const CARD_CAROUSEL_TRANSITION_DURATION_IN_MS = 200;

export const CARD_STATUS_CODES = {
  UNLOCK: "UNLOCK",
  LOCK: "LOCK",
} as const;

export const ONBOARDING_CARD_MOTION = { sheen: { duration: 0.9, ease: STANDARD_EASING } } as const;
